import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Divider, message, Spin } from "antd";
import { useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const echoFieldKeys = ['version', 'locationX', 'locationY', 'locationZ', 'pitch', 'yaw', 'roll'] as const;

const AxForwardCameraForm = (props: iProps) => {

    const { id, sn, onRefreshAll } = props
    const [isLoading, setIsLoading] = useState(false);

    const triggerAutoCalibration = async () => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        try {
            const queryRes = await getDeviceCalibrateResultRequest({ id, sn });
            if (queryRes.data?.code !== 0) {
                return;
            }
            const data = queryRes.data?.data || {};
            const params: Record<string, any> = {
                id,
                success: 0,
            };
            echoFieldKeys.forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    params[key] = data[key];
                }
            });
            const res = await editDeviceCalibrateResultRequest(params, sn);

            if (res.data.code === 0) {
                message.success('触发前视相机自动标定成功');
                onRefreshAll?.();
            } else {
                message.error('触发前视相机自动标定失败');
            }
        } catch (error) {
            console.error("trigger auto calibration failed:", error);
            message.error('触发前视相机自动标定失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>前视相机自动标定</Divider>
        <Spin spinning={isLoading}>
            <div style={{ textAlign: 'right', minHeight: 32 }}>
                <Button
                    type="primary"
                    disabled={isLoading}
                    onClick={triggerAutoCalibration}
                >
                    触发 前视相机自动标定
                </Button>
            </div>
        </Spin>
    </div>
};

export default AxForwardCameraForm;
